"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function CheckThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polyline", { points: "2 7.25721965 6.23172877 11.5203054 14.9104797 3", stroke: "currentColor", fill: "none" })));
}
exports.default = CheckThin;
//# sourceMappingURL=CheckThin.js.map